import { c as _c } from "react/compiler-runtime";
import React, { type FC, useMemo } from 'react';
import { Api, type ApiConfig } from '../Api';
type ApiState = {
  api: Api | null;
};
type IApiContext = ApiState;
const defaultState: ApiState = {
  api: null
};
export const defaultApiContext: IApiContext = {
  ...defaultState
};
export const ApiContext = React.createContext(defaultApiContext);
type Props = {
  apiConfig: ApiConfig;
  children: React.ReactNode;
};
export const ApiProvider: FC<Props> = t0 => {
  const $ = _c(10);
  let apiConfig;
  let restProps;
  if ($[0] !== t0) {
    ({
      apiConfig,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = apiConfig;
    $[2] = restProps;
  } else {
    apiConfig = $[1];
    restProps = $[2];
  }
  let t1;
  if ($[3] !== apiConfig) {
    t1 = new Api(apiConfig);
    $[3] = apiConfig;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const api = t1;
  let t2;
  if ($[5] !== api) {
    t2 = {
      api
    };
    $[5] = api;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== restProps || $[8] !== t2) {
    t3 = <ApiContext.Provider value={t2} {...restProps} />;
    $[7] = restProps;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};